<template>
	<div class="col-md-4">
		<div class="form-group">
			<label>{{label}}<span class="required">*</span>
    </label>
			<input type="text"  class="form-control text-uppercase"
						   v-model="value[name]"
						 :name="name" v-validate="'required'" :maxlength="length"
         
						 :placeholder="placeholder" v-only-text-number v-only-uppercase/>
      <div v-show="errors.has(name)" class="help is-danger">{{required_message}}</div>
		</div>
 
	</div>
</template>
<script>
	export default {
	name: 'ALPHANUM', inject: ['$validator'],
	props: ['placeholder', 'label', 'name', 'value','required_message','length','regularexpression'],


	}
</script>
